import type { TOverriddenChannelsData } from "components/TitleFormContainer/types";
import { getChannelType } from "components/TitleFormContainer/utils";
import { SmallBody } from "helpers/TypographyComponents";
import { applyVatToPrice, formatNumber, getCountryName } from "helpers/utils";
import type { Currencies } from "store/settingsStore";

import styles from "./style.module.scss";

interface ICountryMarketData {
    /**
     * Title country market data
     */
    data: TOverriddenChannelsData[];
    isMobile?: boolean;
    /**
     * "uses_price_with_vat" Company settings
     */
    usesPriceWithVat?: boolean;
    /**
     * Company base currency
     */
    companyCurrency?: string;
    companyCountry?: string;
}

const CountryMarketData = ({
    data,
    isMobile = false,
    usesPriceWithVat,
    companyCurrency,
    companyCountry,
}: ICountryMarketData) => {
    return (
        <>
            <td />
            <td />
            <td
                style={{
                    paddingTop: "0",
                }}
            >
                {data?.map((channel) => {
                    const chType = getChannelType(channel, companyCurrency);

                    return (
                        <div
                            className={styles["title-country-market-prices"]}
                            key={`title-country-market-${channel.countryMarket}`}
                        >
                            <SmallBody color="grey">
                                {isMobile ? channel.countryMarket : getCountryName(channel.countryMarket as string)}
                            </SmallBody>
                            <SmallBody color="grey">
                                {isMobile
                                    ? formatNumber(+channel.price / 100, {
                                          isCurrency: true,
                                          always2Digit: true,
                                          preferredCurrency: channel.currency as Currencies,
                                      })
                                    : formatNumber(
                                          Math.round(
                                              usesPriceWithVat && chType?.isCompanyCurrency
                                                  ? applyVatToPrice(
                                                        +channel.price,
                                                        channel.countryMarket || companyCountry || "",
                                                    )
                                                  : +channel.price,
                                          ) / 100,
                                          {
                                              isCurrency: true,
                                              always2Digit: true,
                                              preferredCurrency: channel.currency as Currencies,
                                          },
                                      )}
                            </SmallBody>
                        </div>
                    );
                })}
            </td>
        </>
    );
};

export default CountryMarketData;
